export default {
  "content": "<path d=\"M18 21H6v-2h12v2zM8 11a4 4 0 008 0V3h2v8a6 6 0 01-12 0V3h2v8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};